import {
  getPlacementQueryOptions,
  getPlacementsByPlatformQueryOptions,
} from "../../queries/placements";
import { getPlatformsQueryOptions } from "../../queries/platforms";

// placements are pre-fetched when a user hover a 'placements' link within a platform
export const placementListByPlatformLoader = ({
  params,
  context: { queryClient },
}) => {
  const { platformId } = params;
  queryClient.ensureQueryData(getPlacementsByPlatformQueryOptions(platformId, queryClient));
};

// necessary entities are pre-fetched when a user hover a 'create placement' or a 'edit placement' link
export const placementFormLoader = ({ context: { queryClient } }) => {
  queryClient.ensureQueryData(getPlatformsQueryOptions());
};

// placement is pre-fetched when a user hover a 'view placement' link
export const placementViewLoader = ({ params, context: { queryClient } }) => {
  const { placementId } = params;
  queryClient.ensureQueryData(getPlacementQueryOptions(placementId, queryClient));
};
